import { Component, Input } from '@angular/core';
import { ICardInfoData } from '../../interfaces/card-info.interface';

@Component({
  selector: 'app-card',
  imports: [],
  templateUrl: './card.html',
  styleUrl: './card.scss'
})
export class Card {

  @Input() info!: ICardInfoData;
}
